/**
 * SGKC011A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc011aReqSlideadjustmentunitpriceSearchinfoDto {

    /**
     * 会社グループコード
     */
    companygroupcode?: string;
    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * ＬＰ販売形態コード
     */
    lpSalesformcode?: string;
    /**
     * 承認権限コード
     */
    apprvAuthorityCode?: string;
    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * 適用年月（開始）
     */
    applyYmStart?: string;
    /**
     * 適用年月（終了）
     */
    applyYmEnd?: string;
    /**
     * 承認ステータスコード
     */
    apprvStatuscode?: string;
}

